import { useQuery } from "@tanstack/react-query"
import { GetInviteSchema } from "schema"
import { z } from "zod"
import { authInviteQuery } from "../lib/authInviteQuery"

export function useAuthInviteQuery(data: z.infer<typeof GetInviteSchema>) {
  return useQuery(authInviteQuery(data))
}
